import { createContext } from "react";

// createContext takes the value which is provided when there is no context provider present.
export const CartContext = createContext(null);
